import usePaymentRequest from './paymentRequest';

export default function usePaymentWithCourtesy() {

  const { paymentRequest } = usePaymentRequest()

  const payWithCourtesy = async ({ paymentContext, moveToCart }) => {

    await paymentRequest({ paymentContext, moveToCart });

    return false;

  }

  return { payWithCourtesy };

}